module.exports = __webpack_public_path__ + "img/REFRESH.e9a3871a.svg";